import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { smartyValidateAddress } from '../api/smartystreets';
import {
    errorRequestingAddress,
    receivedAddress,
    types
} from '../actions/smartystreets';

// tries to fetch addr from smarty api
// on success, puts the RECEIVED_ADDRESS action with a payload of the response
// on error puts the ERROR_REQUESTING_ADDRESS action
export const fetchAddressFromApi = function *(action) {
    try {
        const {payload: {address}} = action;
        const addressFromApi = yield call(smartyValidateAddress, address);

        yield put(receivedAddress(addressFromApi));
        return addressFromApi;
    } catch (error) {
        console.log("Error validating address: ", error);
        yield put(errorRequestingAddress(error));
    }
}

// entry point calls this
// and when the REQUEST_ADDRESS action happens
// calls fetchAddressFrom Api
const watchRequestAddress = function *() {
    yield takeLatest(types.REQUEST_ADDRESS, fetchAddressFromApi);
}

// the actual entry point of the saga
export default function *validateAddress () {
    yield [
        fork(watchRequestAddress)
    ];
}


// WEBPACK FOOTER //
// ./src/sagas/smartystreets.js